module.exports = __webpack_public_path__ + "img/splash-2-small.57895537.png";